import { MOCK_INSTITUTIONS } from "./mock/dashboardData";

/** Empty until hydrated from API or reset to local mock. Avoids flashing mock rows on live sessions. */
let institutions = [];
let source = "empty"; // "empty" | "local" | "api"

const listeners = new Set();

function notify() {
  listeners.forEach((fn) => fn());
}

export function subscribeInstitutions(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getInstitutions() {
  return institutions;
}

export function getInstitutionsSource() {
  return source;
}

export function getInstitutionById(id) {
  const key = String(id);
  return institutions.find(
    (item) =>
      String(item.id) === key ||
      String(item.provider_slug) === key ||
      String(item.numericId) === key
  );
}

function matchesInstitution(item, id) {
  const key = String(id);
  return (
    String(item.id) === key ||
    String(item.provider_slug) === key ||
    String(item.numericId) === key
  );
}

export function updateInstitution(id, patch) {
  let found = false;
  institutions = institutions.map((item) => {
    if (!matchesInstitution(item, id)) return item;
    found = true;
    return { ...item, ...patch };
  });
  // Always new array reference so React subscribers re-render reliably.
  institutions = [...institutions];
  notify();
  return found ? getInstitutionById(id) : null;
}

export function addInstitution(institution) {
  institutions = [institution, ...institutions];
  if (source === "empty") source = "local";
  notify();
  return institution;
}

export function removeInstitution(id) {
  institutions = institutions.filter((item) => !matchesInstitution(item, id));
  notify();
}

/** Clear local rows before a live API fetch (prevents stale/mock flash). */
export function clearInstitutionsForApiLoad() {
  source = "empty";
  institutions = [];
  notify();
  return institutions;
}

/** Replace local list with API institutions. */
export function hydrateInstitutionsFromApi(list) {
  source = "api";
  institutions = Array.isArray(list) ? [...list] : [];
  notify();
  return institutions;
}

export function resetInstitutionsToLocal() {
  source = "local";
  institutions = MOCK_INSTITUTIONS.map((item) => ({ ...item }));
  notify();
}

export function getInstitutionCaseFilterName(institution) {
  return institution?.caseInstitutionLabel ?? institution?.name ?? "";
}

export function resolveInstitutionByLabel(label) {
  if (!label) return null;
  const normalized = String(label).trim().toLowerCase();
  return (
    getInstitutions().find(
      (item) =>
        item.caseInstitutionLabel?.toLowerCase() === normalized ||
        item.name?.toLowerCase() === normalized ||
        item.name?.toLowerCase().startsWith(normalized) ||
        normalized.startsWith(item.name?.toLowerCase().split(" ")[0] ?? "")
    ) ?? null
  );
}
